import { render, staticRenderFns } from "./RouteQuotationDetail.vue?vue&type=template&id=1671b99c&"
import script from "./RouteQuotationDetail.vue?vue&type=script&lang=js&"
export * from "./RouteQuotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteQuotationDetail.vue?vue&type=style&index=0&id=1671b99c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports